<template lang="pug">
<div>
  navigation-bar
  nuxt(keep-alive style='min-height:calc(100vh - 78px - 150px)' :key="$route.fullPath")
  fixed-bar
</div>
</template>

<script>
import NavigationBar from '../components/navigation-bar'
import FixedBar from '../components/fixed-bar-society.vue'

export default {
  name: 'default',
  data() {
    return {
      disabled: true,
      noShow: ['screen'],
      include: { include: ['home', 'screen'] }
    }
  },
  components: {
    NavigationBar,
    'fixed-bar': FixedBar
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.$Lazyload.$on('error', (target) => {
      target.el.src = 'https://static.loklok.video/img/default-sq.png'
    })
  }
}
</script>

<style lang="sass">
// @import '~/styles/index.sass'
</style>
